var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container login-component" }, [
    _c("div", { staticClass: "d-md-flex justify-content-md-center" }, [
      _c("div", { staticClass: "d-md-flex" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-column justify-content-between" },
          [
            _c("p", { staticClass: "heading-small" }, [
              _vm._v(_vm._s(_vm.$t("login_account"))),
            ]),
            _c(
              "router-link",
              {
                staticClass: "login-btn main-btn",
                attrs: { to: { name: "login" } },
              },
              [_vm._v(_vm._s(_vm.$t("login_auth")))]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "or grey" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("or")))]),
        ]),
        _c(
          "div",
          { staticClass: "row align-items-md-end justify-content-center" },
          [
            _c("div", { staticClass: "col-12 col-sm-auto" }, [
              _c(
                "button",
                {
                  staticClass: "google-login-btn",
                  attrs: { loading: _vm.loadingGoogle },
                  on: {
                    click: function ($event) {
                      return _vm.loginGoogle()
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("continue_with")) + " Google"),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "col-12 col-sm-auto" }, [
              _c(
                "button",
                {
                  staticClass: "facebook-login-btn",
                  attrs: { loading: _vm.loadingFacebook },
                  on: {
                    click: function ($event) {
                      return _vm.loginFacebook()
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("continue_with")) + " Facebook"),
                  ]),
                ]
              ),
            ]),
            ["ios", "desktop"].includes(_vm.os())
              ? _c("div", { staticClass: "col-12 col-sm" }, [
                  _c(
                    "button",
                    {
                      staticClass: "apple-login-btn",
                      attrs: { loading: _vm.loadingApple },
                      on: {
                        click: function ($event) {
                          return _vm.loginApple()
                        },
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("continue_with")) + " Apple"),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "new-account" },
        [
          _c("p", { staticClass: "create-account heading-small" }, [
            _vm._v(_vm._s(_vm.$t("login_component_no_account"))),
          ]),
          _c(
            "router-link",
            {
              staticClass: "register-link heading-small",
              attrs: { to: { name: "new-account" } },
            },
            [_vm._v(_vm._s(_vm.$t("new_account_title")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }